var PresetService = require('../../../src/dashboard/PresetService').default;

function PresetShareController($scope, $element, eventSender, $q, socket, serviceUtility, serviceSession, serviceAuth, serviceMessageBus) {
	$scope.msgbus = serviceMessageBus.get();
	$scope.listShare = [];
	var dataSecurityGroups = [];
	$scope.canWrite = false;
	$scope.presetShareModalSrc = '';

	$scope.$on('PresetShareController:setPreset', openSharePresetDialog);
	$scope.$on('PresetShareController:setPresetInfo', openShareInfoDialog);

	$scope.hidePresetShareModal = hidePresetShareModal;
	$scope.hidePresetShareListModal = hidePresetShareListModal;

	function openSharePresetDialog(e, currentPreset) {
		$scope.presetShareModalSrc = '/package/system/dashboard/view.PresetShareModal.html';

		$scope.listShare.splice(0, $scope.listShare.length);
		$scope.currentPreset = currentPreset;

		getSecurityGroups().success(function(m) {
			dataSecurityGroups = m.body.security_groups;
			setCurrentGrants(currentPreset);
			$scope.$apply();
		});
	}

	$scope.onLoadPresetShareModal = function() {
		$element.find('.mdlPresetShare')[0].showDialog();
	}

	function hidePresetShareModal() {
		$scope.presetShareModalSrc = '';
		$element.find('.mdlPresetShare')[0].hideDialog();
	}

	function openShareInfoDialog(e, currentPreset) {
		$element.find('.mdlPresetShareInfo')[0].showDialog();
		$scope.currentPreset = currentPreset;
		checkCanWrite(currentPreset);
	}

	function checkCanWrite(preset) {
		var belongsToUsers = preset.write_grants.indexOf(serviceSession.whoAmI()) !== -1;
		serviceAuth.getMySecurityGroups().success(function(m) {
			var guids = m.body.security_groups.map(function(item) {
				return item.guid;
			});

			var belongsToGroup = preset.write_grant_groups.some(function(group) {
				return guids.indexOf(group) !== -1
			});

			$scope.canWrite = belongsToUsers || belongsToGroup;
			$scope.$apply();
		})
		.failed(function(m, raw) {
			console.warn(m, raw);
			$scope.canWrite = false;
			$scope.$apply();
		});
	}


	function findFromShareList(type, guid) {
		return $scope.listShare.filter(function(item) {
			return item.type === type && item.guid === guid;
		}).first();
	}

	function findSecurityGroupNameByGuid(guid) {
		var obj = dataSecurityGroups.filter(function(item) {
			return item.guid === guid;
		}).first();
		if(!obj) {
			return guid;
		}
		else {
			return obj.name;
		}
	}

	function getSecurityGroups() {
		return socket.send('org.araqne.logdb.msgbus.ManagementPlugin.listSecurityGroups', {}, eventSender.dashboard.pid)
	}

	function setCurrentGrants(currentPreset) {
		if(Array.isArray(currentPreset.read_grants)) {
			currentPreset.read_grants.forEach(function(login_name) {
				$scope.listShare.push({
					'type': 'user',
					'guid': login_name,
					'text': login_name,
					'can_read': true
				});
			});
		}

		if(Array.isArray(currentPreset.read_grant_groups)) {
			currentPreset.read_grant_groups.forEach(function(guid) {
				$scope.listShare.push({
					'type': 'group',
					'text': findSecurityGroupNameByGuid(guid),
					'guid': guid,
					'can_read': true
				});
			});
		}

		if(Array.isArray(currentPreset.write_grants)) {
			currentPreset.write_grants.forEach(function(login_name) {
				var user = findFromShareList('user', login_name);
				if(!user) {
					$scope.listShare.push({
						'type': 'user',
						'guid': login_name,
						'text': login_name,
						'can_read': true,
						'can_write': true
					});
				}
				else {
					user.can_write = true;
				}
			});
		}

		if(Array.isArray(currentPreset.write_grant_groups)) {
			currentPreset.write_grant_groups.forEach(function(guid) {
				var group = findFromShareList('group', guid);
				if(!group) {
					$scope.listShare.push({
						'type': 'group',
						'text': findSecurityGroupNameByGuid(guid),
						'guid': guid,
						'can_read': true,
						'can_write': true
					});
				}
				else {
					group.can_write = true;
				}
			});
		}
	}

	$scope.loadTags = serviceUtility.qDebounce(function(query) {
		var deferred = $q.defer();

		var modal = $element.find('.mdlPresetShare').parents('.modal').first();
		modal.addClass('modal-overflow');

		socket.send([
			'org.araqne.dom.msgbus.UserPlugin.getUsers'
		], [
			{ 'filter_login_name': query, 'filter_name': query },
		], eventSender.dashboard.pid).success(function(m1, m2) {

			var source1 = m1.body.users.map(function(user) {
				return {
					'text': user.login_name,
					'guid': user.login_name,
					'type': 'user',
					'can_read': true
				};
			});

			var source2 = dataSecurityGroups.filter(function(group) {
				return group.name.indexOf(query) !== -1;
			}).map(function(group) {
				return {
					'text': group.name,
					'guid': group.guid,
					'type': 'group',
					'can_read': true
				}
			});

			deferred.resolve(
				source1.concat(source2).sort(function(a, b) {
					if(a.text.length > b.text.length) {
						return 1;
					} else {
						return -1;
					}
				})
			);
		});

		return deferred.promise;
	}, 250);

	$scope.onTagAdding = function(tag) {
		return !!tag.type;
	}

	$scope.onTagAdded = function() {
		var modal = $element.find('.modal-overflow');
		modal.removeClass('modal-overflow');
	}

	// 목록에서 선택 모달
	function openPresetShareListModal() {
		$element.find('.mdlPresetShareList')[0].showDialog();
	}

	function hidePresetShareListModal() {
		$element.find('.mdlPresetShareList')[0].hideDialog();
	}

	function initPresetShareList(array) {
		if(Array.isArray(array)) {
			for(var i = 0 ; i < array.length ; i++) {
				array[i]['is_checked'] = false;
			}
		}
	}

	function commitValues(type, srcArray, dstArray) {
		if(Array.isArray(srcArray) && Array.isArray(dstArray)){
			var text, guid, item, obj, found;
			for(var index = 0, length = srcArray.length; index < length ; index++) {
				item = srcArray[index];

				if(type === 'user') {
					text = item.login_name;
					guid = item.login_name;
				}else {
					text = item.name;
					guid = item.guid
				}
				
				obj = {
					'text': text,
					'guid': guid,
					'type': type,
					'can_read': true
				}

				found = hasInTags(obj);

				if(item.is_checked) {
					if(!found.has) {
						dstArray.push(obj);
					}
				}else {
					if(found.has) {
						dstArray.splice(dstArray.indexOf(found.items[0]), 1);
					}
				}
			}
		}
	}

	$scope.openList = function() {
		$scope.listUser = $scope.listShare.filter(function(item) {
			return item.type === 'user'
		}).map(function(item) {
			return item.text;
		});
		
		$scope.listSecurityGroup = $scope.listShare.filter(function(item) {
			return item.type === 'group'
		}).map(function(item) {
			return item.text;
		});
		
		$('.userPresetShare')[0].setGrants($scope.listUser);
		$('.userPresetShareGroup')[0].setGrants($scope.listSecurityGroup);
		openPresetShareListModal();
	}

	$scope.removeFromList = function(idx) {
		$scope.listShare.splice(idx, 1);
	}

	function hasInTags(obj) {
		var filter = $scope.listShare.filter(function(tag) {
			return tag.text === obj.text && tag.type === obj.type;
		});
		return {
			'items': filter,
			'has': filter.length > 0,
			'length': filter.length
		}
	}

	$scope.assignChecked = function() {
		$scope.listShare.forEach(function(share) {
			$scope.listUser.some(function(user) {
				var isEqual = share.text === user.login_name && share.guid === user.login_name;
				if(isEqual) {
					user.is_checked = true;
				}
				return isEqual;
			});
		});
	}

	$scope.assignCheckedGroup = function() {
		$scope.listShare.forEach(function(share) {
			$scope.listSecurityGroup.some(function(group) {
				var isEqual = share.text === group.name && share.guid === group.guid;
				if(isEqual) {
					group.is_checked = true;
				}

				return isEqual;
			});
		});
	}

	$scope.commit = function() {
		$scope.listShare = [];
		commitValues('user', $scope.listUser, $scope.listShare);
		commitValues('group', $scope.listSecurityGroup, $scope.listShare);

		hidePresetShareListModal();
	}

	$scope.checkReadAlso = function(user) {
		if(user.can_write) {
			user.can_read = true;
		}
	}

	$scope.share = function() {
		var hasNoSetting = $scope.listShare.some(function(item) {
			var cond = !item.can_read && !item.can_write;
			if(cond) {
				item.invalid = true;
			}
			return cond;
		});

		if(hasNoSetting) {
			return;
		}

		var obj = {
			read_grants: [],
			read_grant_groups: [],
			write_grants: [],
			write_grant_groups: []
		};

		$scope.listShare.forEach(function(item) {
			if(item.can_read && item.type === 'user') {
				if(item.can_write) {
					obj.write_grants.push(item.guid);
				}
				obj.read_grants.push(item.guid);
			}
			else if(item.can_read && item.type === 'group') {
				if(item.can_write) {
					obj.write_grant_groups.push(item.guid);
				}
				obj.read_grant_groups.push(item.guid);
			}
			else {
				console.warn(item);
			}
		});

		PresetService.grantPreset($scope.msgbus, $scope.currentPreset, obj)
		.onSuccess(function(changes) {
			hidePresetShareModal();
			$scope.$emit('DashboardContainerController:onParentPresetChanged', changes);
		});

	}

}

module.exports = PresetShareController;


// WEBPACK FOOTER //
// ./resources/WEB-INF/package/system/dashboard/PresetShareController.js